import _ from 'lodash';

function ManagerAdminCtrl($rootScope, $scope, $http, $window, $timeout, $state, $stateParams, $compile,$q, toastr, AppSettings, UserService, PlanService, PlayerService, AuthService, AppContextService, $ngConfirm, TeamService, BioService, AnalysisService) {
  'ngInject';

  const vm = this;
  vm.appContext = AppContextService.context;

  
  // 팀 선택 메뉴 생성
  UserService.getCountries().then(function (res) {
    vm.adminContinents = res.data.list;

    if ($stateParams.continent_id) {
      vm.adminContinent = _.find(vm.adminContinents, {
        id: +$stateParams.continent_id
      });
    } else {
      vm.adminContinent = vm.adminContinents[0];
    }
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });

  // 대륙 변경
  $scope.$watch('vm.adminContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.adminCountries = res.data.list;
        vm.adminTeams1 = vm.adminTeams2 = vm.adminTeams3 = vm.adminTeams4 = null;

        if ($stateParams.country_id) {
          vm.adminCountry = _.find(vm.adminCountries, {
            id: +$stateParams.country_id
          });
        } else {
          vm.adminCountry = vm.adminCountries[0];
        }

        $state.transitionTo('Service.managerAdmin', {continent_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          reloadOnSearch: false
        });
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 국가 변경
  $scope.$watch('vm.adminCountry', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: newVal.id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.adminTeams1 = res.data.list;

          if ($stateParams.team1_id) {
            vm.adminTeam1 = _.find(vm.adminTeams1, {
              id: +$stateParams.team1_id
            });
          } else {
            vm.adminTeam1 = vm.adminTeams1[0];
          }

          $state.transitionTo('Service.managerAdmin', {country_id: newVal.id}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            reloadOnSearch: false
          });

          vm.adminTeams2 = vm.adminTeams3 = vm.adminTeams4 = null;
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
    }
  });

  // 팀 1단계 변경
  $scope.$watch('vm.adminTeam1', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: vm.adminCountry.id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.adminTeams2 = res.data.list;

        if ($stateParams.team2_id) {
          vm.adminTeam2 = _.find(vm.adminTeams2, {
            id: +$stateParams.team2_id
          });
        }

        $state.transitionTo('Service.managerAdmin', {team1_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          reloadOnSearch: false
        });
        
        vm.adminTeams3 = vm.adminTeams4 = null;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 팀 2단계 변경
  $scope.$watch('vm.adminTeam2', function (newVal, oldVal) {

    if (newVal) {
      UserService.getTeams({
        country_id: vm.adminCountry.id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.adminTeams3 = res.data.list;

        if ($stateParams.team3_id) {
          vm.adminTeam3 = _.find(vm.adminTeams3, {
            id: +$stateParams.team3_id
          });
        }

        $state.transitionTo('Service.managerAdmin', {team2_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          reloadOnSearch: false
        });

        vm.adminTeams4 = null;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 팀 3단계 변경
  $scope.$watch('vm.adminTeam3', function (newVal, oldVal) {
    if (newVal) {
      UserService.getTeams({
        country_id: vm.adminCountry.id,
        parent_id: newVal.id
      }).then(function (res) {
        // 전체 관리자는 소속팀이 없는 경우 (team_id: 0) 도 조회할 수 있어야 해서 가상의 팀을 만듬
        var noTeam = {
          id: 0,
          can_have_last: false,
          image_url: "/images/teams/default_user.png",
          is_last: true,
          is_last_admin: true,
          name: '무소속'
        };

        vm.adminTeams4 = res.data.list.concat([noTeam]);

        if ($stateParams.team4_id) {
          vm.adminTeam4 = _.find(vm.adminTeams4, {
            id: +$stateParams.team4_id
          });
        }

        $state.transitionTo('Service.managerAdmin', {team3_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          reloadOnSearch: false
        });
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 팀 4단계 변경
  $scope.$watch('vm.adminTeam4', function (newVal, oldVal) {
    if (newVal) {
      $state.transitionTo('Service.managerAdmin', {team4_id: newVal.id}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        reloadOnSearch: false
      })
    }
  });

  // 팀 선택
  vm.selectTeam = function() {
    $state.transitionTo('Service.managerAdmin', {team_id: vm.adminTeam4.id, manager_admin_team_id: vm.adminTeam4.id}, {
      location: true,
      inherit: true,
      relative: $state.$current,
      reloadOnSearch: false
    }).then(function() {
      vm.appContext.manager_admin_team = {
        parent_team_name: vm.adminTeam3.name,
        team_id: vm.adminTeam4.id,
        team_name: vm.adminTeam4.name,
        country_id: vm.adminCountry.id,
        country_name: vm.adminCountry.name,
      };
  
      $state.go('Service.planner', {type_code:'team',type_name:'팀'});
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };

  // 팀 선택 초기화
  vm.resetTeams = function () {
    vm.adminTeams1 = vm.adminTeams2 = vm.adminTeams3 = vm.adminTeams4 = null;

    vm.appContext.manager_admin_team = null;

    $state.transitionTo('Service.managerAdmin', { team1_id: null, team2_id: null, team3_id: null, team4_id: null, manager_admin_team_id: null }, {
      location: true,
      inherit: true,
      relative: $state.$current,
      reloadOnSearch: false
    });
  };


  /*
  var viewTeamId = 53;

  // 선수목록 조회
  var mainPlayersData = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    team_id: viewTeamId
  };
  PlayerService.getPlayers(mainPlayersData).then(function(res) {
    console.log('main/players', res.data);
  });

  // 생체 정보 조회
  var mainInfoData = {
    mode: 'recent',
    team_id: viewTeamId
  };
  PlayerService.getPlayerBiometricInfo(mainInfoData).then(function(res) {
    console.log('main/info', res.data);
  });

  // 팀 동작/위치 기록 조회
  var mainTeamInfoData = {
    mode: 'recent',
    team_id: viewTeamId
  };
  PlayerService.getPlayerLocationInfo(mainTeamInfoData).then(function(res) {
    console.log('main/team_info', res.data);
  });

  // 일정 조회
  var plansData = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    team_id: viewTeamId
  };
  PlanService.plans(plansData).then(function(res) {
    console.log('plan/plans2', res.data);
  });

  // 건강 기록 조회
  var bioHealthData = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    date: timeToDate(+new Date(), 'dotdate'),
    team_id: viewTeamId
  };
  BioService.healthDataList(bioHealthData).then(function(res) {
    console.log('bio/health', res.data);
  });

  // 부상 목록 조회
  var analysisGetInjurydata = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    date: timeToDate(+new Date(), 'dotdate'),
    team_id: viewTeamId
  };
  AnalysisService.getInjury(analysisGetInjurydata).then(function(res) {
    console.log('analysis/get_injury', res.data);
  }).catch(function(err) {
    console.log('analysis/get_injury error', err);
  });

  // 동영상 목록 조회
  var planGetMurlsData = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    game_id: 599,
    team_id: viewTeamId
  };
  PlanService.getMurls(planGetMurlsData).then(function(res) {
    console.log('plan/get_murls', res.data);
  }).catch(function(err) {
    console.log('plan/get_mulrs error', err);
  });
  */

}

export default {
  name: 'ManagerAdminCtrl',
  fn: ManagerAdminCtrl
};
